import { Component } from '@angular/core';

@Component({
  selector: 'app-invalid-signature',
  imports: [],
  templateUrl: './invalid-signature.component.html',
  styleUrl: './invalid-signature.component.scss'
})
export class InvalidSignatureComponent {

}
